import React from "react"
import cx from "classnames"

import * as s from "./ProductPersonalisation.module.scss"

import { TextArea } from "@components/common/form/TextArea"

export const ProductPersonalisation = ({
  className,
  value,
  onChange,
  error,
}) => {
  return (
    <div className={`${className && className} ${s.ProductPersonalisation}`}>
      <TextArea
        placeholder="Your Name / Message"
        value={value}
        onChange={e => onChange(e.target.value)}
        error={error}
        rows="2"
      />
      {error && (
        <span
          className={cx(s.Error, {
            [s.Error___active]: error,
          })}
        >
          {error}
        </span>
      )}
    </div>
  )
}
